var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, observable, makeObservable } from 'mobx';
import { memoize } from '../../../utils/mobx/decorators/memoize';
import { MenubarUserDialogs } from './Dialogs/MenubarUserDialogs';
import { runtime } from '../../../classes/runtime/Runtime';
export class MenubarUser {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get app() {
        return this.parent.parent;
    }
    get user() {
        return this.app.user;
    }
    isUserMenuOpen = false;
    isUserMenuButtonHovered = false;
    get dialogs() {
        return new MenubarUserDialogs(this);
    }
    get menubarUserSiblings() {
        return new runtime.solidPackages.Lazy.classes.MenubarUserMenuSiblings(this);
    }
    showMenu() {
        this.isUserMenuOpen = true;
    }
    toggleMenu() {
        this.isUserMenuOpen = !this.isUserMenuOpen;
    }
    closeMenu() {
        this.isUserMenuOpen = false;
        this.isUserMenuButtonHovered = false;
    }
}
__decorate([
    observable
], MenubarUser.prototype, "isUserMenuOpen", void 0);
__decorate([
    observable
], MenubarUser.prototype, "isUserMenuButtonHovered", void 0);
__decorate([
    memoize
], MenubarUser.prototype, "dialogs", null);
__decorate([
    memoize
], MenubarUser.prototype, "menubarUserSiblings", null);
__decorate([
    action.bound
], MenubarUser.prototype, "showMenu", null);
__decorate([
    action.bound
], MenubarUser.prototype, "toggleMenu", null);
__decorate([
    action.bound
], MenubarUser.prototype, "closeMenu", null);
